import React, { ReactElement, ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { Icon } from "@sellar-io/components";
import { IconType } from "@sellar-io/components";
import { AlertType } from "./AlertType";

export type AlertStyleType = {
  bgColour: string;
  borderColour: string;
  colour: string;
  icon: keyof typeof IconType;
};

export function AlertCompact({
  type = "default",
  className,
  children,
  onClick,
}: {
  type?: AlertType;
  className?: string;
  children?: ReactNode;
  onClick?: () => void;
}): ReactElement {
  const getMessageStyles = (): AlertStyleType => {
    switch (type) {
      case "information":
        return {
          bgColour: "bg-indigo-100",
          borderColour: "border-indigo-300",
          colour: "text-indigo-800",
          icon: "INFORMATION",
        };
      case "success":
        return {
          bgColour: "text-emerald-800",
          borderColour: "text-emerald-800",
          colour: "text-emerald-800",
          icon: "CHECK_CIRCLE",
        };
      case "warning":
        return {
          bgColour: "bg-orange-100",
          borderColour: "border-orange-300",
          colour: "text-orange-800",
          icon: "CAUTION",
        };
      case "error":
        return {
          bgColour: "text-red-800",
          borderColour: "text-red-800",
          colour: "text-red-800",
          icon: "ALERT_FILLED",
        };
      case "sellar":
        return {
          bgColour: "text-[#b557f1]",
          borderColour: "text-[#b557f1]",
          colour: "",
          icon: "SELLAR",
        };
      case "request":
        return {
          bgColour: "bg-lime-100",
          borderColour: "border-lime-300",
          colour: "text-lime-800",
          icon: "CALENDAR_CLOCK",
        };
      default:
        return {
          bgColour: "",
          borderColour: "",
          colour: "",
          icon: "INFORMATION",
        };
    }
  };

  const { icon, bgColour, borderColour, colour } = getMessageStyles();

  return (
    <div
      className={twMerge(
        "cursor-pointer rounded-lg border",
        bgColour,
        borderColour,
        className,
      )}
      onClick={onClick}
    >
      <div className="flex items-center gap-2 px-3 py-2">
        <Icon size={0.8} icon={icon} className={twMerge(colour, "flex-none")} />
        {children}
      </div>
    </div>
  );
}
